module.exports = __webpack_public_path__ + "img/index22.b88256a6.png";